import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-terms-and-conditions-br',
  templateUrl: 'terms-conditions-br.component.html',
  styleUrls: ['terms-conditions-br.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  standalone: false
})

export class TermsAndConditionsBRComponent { }
